import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

const i18n = i18next.createInstance();
  
i18n
    .use(HttpApi)   // EN: Load translation using http -> see /public/locales
    .use(initReactI18next)   // EN: Pass the i18n instance to react-i18next.
    .init({   // EN: Init i18next
        //debug: import.meta.env.DEV, // EN: Enable debug mode only in development environment
        debug: false, // EN: Disable debug mode for production

        lng: "pl",
        fallbackLng: "pl", // EN: Use Polish if detected language is not available

        supportedLngs: ["pl", "en", "de", "uk", "ko"],

        load: "languageOnly", // EN: Load only the language code (e.g., 'en' instead of 'en-US')
        cleanCode: true, // EN: Remove any non-standard codes from the language code (e.g., 'en-US' becomes 'en')

        ns: [
            "common",
            "auth",
            "product",
            "admin",
            "allergens",
            "errors",
            "checkout",
            "cart",
            "contact",
            "menu",
            "profile",
            "pages",
            "restaurant",
            "legal",
            "booking",
            "translation",
          ],
          
        defaultNS: "common",

        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json", // EN: Path to load translations from
        },
        
        interpolation: {
            escapeValue: false, // EN: React already safes from xss
        },        
    });

export default i18n;
export { i18n };